import { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { Portal, Box } from "@mui/material";
import MyLoadingOperation from "../components/myloader/MyLoadingOperation";

type LoadingContextType = {
  showLoading: () => void;
  hideLoading: () => void;
};

const LoadingContext = createContext<LoadingContextType | null>(null);

export function LoadingProvider({ children }: { children: ReactNode }) {
  const [visible, setVisible] = useState(false);

  const showLoading = useCallback(() => setVisible(true), []);
  const hideLoading = useCallback(() => setVisible(false), []);

  return (
      <LoadingContext.Provider value={{ showLoading, hideLoading }}>
        {children}
        <MyLoadingOperation visible={visible} />
      </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }

  return context;
}
